import { toast, ToastOptions } from 'react-toastify';
import LoadingSpinnerSmall from '@/features/global/loading/LoadingSpinnerSmall';

export const showNavigationWarningToast = () => {
  const options: ToastOptions = {
    toastId: 'NO_NAVIGATION_WHILE_STREAMING',
    theme: 'dark',
    hideProgressBar: true,
    autoClose: 3000,
    closeOnClick: false,
    closeButton: false,
  };

  toast.warning(
    "Sorry, you can't navigate while loading content",
    options
  );
};

export const dismissNavigationWarningToast = () => {
  toast.dismiss('NO_NAVIGATION_WHILE_STREAMING');
}; 